import debounce from 'lodash/debounce';

const numberRegex = /\d+/g;

type Fn = (query: string) => any;

export class Autocomplete {
  private debouncedFn: ReturnType<typeof debounce>;

  constructor(fn: Fn, delay = 500) {
    this.debouncedFn = debounce(fn, delay, { leading: false, trailing: true });
  }

  search(query: string): void {
    let searchValue = query.trim();

    // If it's a number, remove any spaces
    if (numberRegex.test(searchValue)) {
      searchValue = searchValue.replace(/\s/g, '');
    }

    if (searchValue.length <= 1) return;

    this.debouncedFn(searchValue);
  }
}
